import(/* webpackMode: "eager" */ "/www/app/global-error.tsx");
